import React, { useState } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Divider } from '@atomic';
import { PostComment } from '@domain';
import { COLOR_FONT_GRAY } from '@assets/color';
import PostCommentCounter from './PostCommentCounter';

const PostCommentWrapper = styled.ul`
  list-style: none;
  overflow-x: hidden;
  overflow-y: auto;
  height: 254px;
  margin: 0px;
  padding: 0px;

  ::-webkit-scrollbar {
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    height: 40%;
    background-color: ${COLOR_FONT_GRAY};
    border-radius: 20px;
`;

function PostCommentList({ comments, ...props }) {
  const [isFold, setIsFold] = useState(true);
  const computedCount = (comments) =>
    comments?.length === undefined ? 0 : comments?.length;
  const handleFold = () => {
    setIsFold((isFold) => !isFold);
  };

  return (
    <div {...props}>
      <Divider />
      <PostCommentCounter
        isFold={isFold}
        onClick={handleFold}
        commentCount={computedCount(comments)}
      />
      <PostCommentWrapper>
        {isFold &&
          comments?.length > 0 &&
          comments.map((comment, _id) => (
            <PostComment key={_id} comment={comment}></PostComment>
          ))}
      </PostCommentWrapper>
      <Divider />
    </div>
  );
}

PostCommentList.propTypes = {
  comments: PropTypes.array,
};

export default PostCommentList;
